import { render, staticRenderFns } from "./ProjectRate.vue?vue&type=template&id=707b69a4"
import script from "./ProjectRate.vue?vue&type=script&lang=js"
export * from "./ProjectRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports